var r="4.10.11";export{r as version};
//# sourceMappingURL=package.json.js.map
